import React, { FunctionComponent, useState, useEffect } from 'react';
import { Presentation } from './presentation';
import type { Brand, ShowBrandCompany } from '../../../types/brand';
import { getShowBrand, getShowBrandCompany } from '../../../services/brands';
import { ComponentProps as Props } from './types';

export const Component: FunctionComponent<Props> = (props) => {
  const [brandData, setBrandData] = useState<Brand | null>(null);
  const [companyId, setCompanyId] = useState<number | null>(null);

  useEffect(() => {
    const request = async () => {
      const brandResponse = await getShowBrand(props.brandId);
      setBrandData(brandResponse);
      try {
        const companyResponse = await getShowBrandCompany(props.brandId);
        setCompanyId(companyResponse.id);
      } catch (e) {
        setCompanyId(null);
      }
    };
    request();
  }, []);

  return <Presentation brandData={brandData} companyId={companyId} {...props} />;
};
